module.exports = __webpack_public_path__ + "img/1518295369.1f23bdab.jpg";